import axiosAuth from "@/services/axiosAuth";
import { UseMutationOptions, useMutation } from "@tanstack/react-query";
import { PROJECT_API } from "./apiRoutes";

interface mutateProps {
  projectId: string;
  planId: string;
  data: any
}

const mutateUpdatedPlanStatus = async ({projectId, planId, data}: mutateProps) => {
  return await axiosAuth.post(`${PROJECT_API}/${projectId}/plans/${planId}/change-status`, data);
};

const useUpdatedPlanStatusMutation = (
  queryParams?: UseMutationOptions<any, Error, mutateProps, unknown>
) =>
  useMutation({
    mutationFn: mutateUpdatedPlanStatus,
    ...queryParams,
  });

export default useUpdatedPlanStatusMutation;
